/** @jsx jsx */
import React, { useContext } from "react";
import { grayScale } from "components/styles";
import Accordion from "components/molecules/Accordion";
import DataTable from "components/organismos/DataTable/DataTable";
import { css, jsx } from "@emotion/core";
import { useHistory } from "react-router-dom";
import { SubActionButton } from "components/atoms/Button";
import { ActionButton } from "components/atoms/Button/SubActionButton";
import moment from "moment";
import FlexBox from "components/atoms/FlexBox";
import RejectedOvertimeDomain from "../domain/rejectedOvertimeDomain";
import Modal from "components/molecules/Modal";
import IconLabelButton from "components/molecules/IconLabelButton";
import { useApplyingTransferForm } from "../ApplyingTab/hook";
import ChangeLogModal from "components/molecules/ChangeLogModal";
import { AttendApplicationListContext } from "../AttendApplicationListV3";

const OvertimeAccordion: React.FC<{ list: RejectedOvertimeDomain[] }> = ({ list }) => {
  const history = useHistory();
  const {
    changeLogData,
    setChangeLogData,
    changeLogModalOpen,
    setChangeLogModalOpen,
    setSelectChangelog,
    fetchChangeLogOverTime,
  } = useApplyingTransferForm(list);
  const { detailRole } = useContext(AttendApplicationListContext);

  const columns = React.useMemo(
    () => [
      {
        Header: "",
        id: "edit",
        accessor: "edit",
        Cell: (cell: { row: { isExpanded: boolean; original: any; index: number }; data: any }) => (
          <FlexBox customStyle={css({ justifyContent: "space-evenly" })}>
            {detailRole.editable === 1 && (
              <SubActionButton
                text="再申請"
                onClick={() => {
                  console.log("xxxx", cell.row.original);
                  sessionStorage.setItem(
                    "attendStampList.targetDateFrom",
                    moment(cell.row.original.stampListStartTime).format("YYYY-MM-DD"),
                  );
                  sessionStorage.setItem(
                    "attendStampList.targetDateTo",
                    moment(cell.row.original.stampListEndTime).format("YYYY-MM-DD"),
                  );
                  sessionStorage.setItem("attendStampList.orgCode", String(cell.row.original.orgCode));
                  sessionStorage.setItem("attendStampList.staffCode", String(cell.row.original.staffCode));

                  sessionStorage.setItem("application.orgCode", String(cell.row.original.orgCode));
                  sessionStorage.setItem("application.staffCode", String(cell.row.original.staffCode));

                  sessionStorage.setItem(
                    "application.dispStaffName",
                    `${cell.row.original.staffCode} ${cell.row.original.staffName}`,
                  );
                  sessionStorage.setItem(
                    "application.targetDate",
                    moment(cell.row.original.targetDate).format("YYYY-MM-DD"),
                  );

                  sessionStorage.setItem("application.achievementId", cell.row.original.achievementId || "");

                  sessionStorage.setItem("application.returnDestination", window.location.pathname);
                  sessionStorage.setItem("attendStampList.returnDestination", window.location.pathname);

                  history.push("attendApplicationList/attendOvertimeApplication");
                }}
                action={ActionButton.EDIT}
              />
            )}
          </FlexBox>
        ),
        disableSortBy: true,
      },
      {
        Header: "差戻者",
        accessor: "authorizer",
      },
      {
        Header: "差戻日時",
        accessor: "approvalDate",
      },

      {
        Header: "申請者",
        accessor: "applicant",
      },
      {
        Header: "申請日時",
        accessor: "applicationDate",
      },
      {
        Header: "対象者",
        accessor: "targetPerson",
      },
      {
        Header: (any: any) => "対象日付",
        id: "",
        accessor: "targetDate",
        Cell: (cell: { row: { isExpanded: boolean; original: any; index: number }; data: any }) => {
          return (
            <div style={{ textAlign: "center" }}>
              <div>
                <div>{cell.row.original.targetDate}</div>
                <IconLabelButton
                  onClick={() => {
                    fetchChangeLogOverTime(cell.row.original.rawData);
                    setChangeLogModalOpen(true);
                    setSelectChangelog("0");
                  }}
                  text="更新履歴"
                  textAlign="center"
                  isIcon={false}
                />
              </div>
            </div>
          );
        },
      },
      {
        Header: "申請種別",
        accessor: "modifiyStatusName",
      },
      {
        Header: "出勤組織",
        accessor: "orgName",
      },
      {
        Header: "残業時間",
        accessor: "unapprovedOvertime",
      },
      {
        Header: "申請残業時間",
        accessor: "applicationOvertime",
      },
      {
        Header: "差戻者コメント",
        accessor: "rejectReason",
      },
    ],
    [history, fetchChangeLogOverTime, setChangeLogModalOpen, setSelectChangelog, detailRole.editable],
  );

  return (
    <React.Fragment>
      <div
        css={css`
          table th:nth-of-type(1) {
            width: 50px;
          }
          table th:nth-of-type(2) {
            width: 140px;
          }
          table th:nth-of-type(3) {
            width: 140px;
          }
          table th:nth-of-type(4) {
            width: 140px;
          }
          table th:nth-of-type(5) {
            width: 140px;
          }
          table th:nth-of-type(6) {
            width: 140px;
          }
          table th:nth-of-type(7) {
            width: 140px;
          }
          table th:nth-of-type(8) {
            width: 80px;
          }
          table th:nth-of-type(9) {
            width: 120px;
          }
          table th:nth-of-type(10) {
            width: 80px;
          }
          table th:nth-of-type(11) {
            width: 80px;
          }
          table th:nth-of-type(12) {
            width: 200px;
          }
        `}
      >
        <Accordion text={`残業申請 (${list.length}件）`} callBack={() => {}}>
          <DataTable
            columns={columns}
            containerStyle={css({
              overflowX: "auto",
              marginTop: "15px",
            })}
            data={list}
            isGlobalFilter={true}
            sortBy={[{ id: "targetDate", desc: true }]}
          />
        </Accordion>
      </div>
      {/* Change log  */}
      <div css={css(">div>div{ width: 800px }")}>
        <Modal
          closeHandler={() => {
            setChangeLogModalOpen(false);
            setChangeLogData([]);
          }}
          open={changeLogModalOpen}
          title="更新履歴"
          submitText="閉じる"
          onSubmit={() => {
            setChangeLogModalOpen(false);
            setChangeLogData([]);
          }}
          closeText=""
        >
          <ChangeLogModal changeLogData={changeLogData} request="残業申請" />
        </Modal>
      </div>
      {/* ./Change log  */}
    </React.Fragment>
  );
};

export default OvertimeAccordion;
